export default {

  /**
   * @description 配置显示在浏览器标签的title
   */
  version: '0.0.5',
  /**
   * @description 配置显示在浏览器标签的title
   */
  title: 'Church\'s Reporting',
  /**
   * @description token 在 Cookie 中存储的天数，默认 1 小时
   */
  cookieExpires: 1 / 24,
  /**
   * @description token 在 Cookie 中的 Key
   */
  TOKEN_KEY: 'token',

  /**
   * @description userId 在 Cookie 中的 Key
   */
  USER_ID_KEY: '_l_u',

  /**
   * @description setting 在 localStorage 中的 Key
   */
  SETTING_KEY: 'app.settings',

  /**
   * @description password 在 Cookie 中的 Key
   */
  PASSWORD_KEY: '_l_p',
  /**
   * @description user 在 Cookie 中存储的天数，默认 7 天
   */
  cookieExpiresForUser: 7,

  /**
   * @description 是否使用国际化，默认为false
   *              如果不使用，则需要在路由中给需要在菜单中展示的路由设置meta: {title: 'xxx'}
   *              用来在菜单中显示文字
   */
  useI18n: false,

  /**
   * @description 默认打开的首页的路由name值，默认为home
   */
  homeName: 'web',
  /**
   * @description 登陆界面在路由里的 name
   */
  loginPageName: 'login',
  /**
   * @description api请求基础路径
   */
  baseUrl: {
    dev: 'http://127.0.0.1:8082/',  // dev backend api url
    //dev: 'https://churchsreports.nextxnow.com/',  // dev backend api url
    //dev: 'http://172.31.1.176:9091/',  // dev backend api url
    pro: 'https://churchsreports.nextxnow.com/',  // live backend api url for Production (build)
   // pro: 'http://10.0.0.80:8082/',  // live backend api url for Production (build)
  },

  /**
   * @description http timeout
   */
  timeout: 10000,

  /**
   * @description 获取 academy video 的 url
   */
  academyUrl: '/'
}



// WEBPACK FOOTER //
// ./src/config/index.js